import { IDatasource, IDatasourceReportFn } from 'core-ts-types';
import { IReminderData } from '../personal_reminder_interface';
import * as _4 from 'lodash4';

export class ReminderConfirmDatasource implements IDatasource {
  private sourceReminderData: IReminderData;

  constructor() {
    this.initialize();
  }

  initialize(): ReminderConfirmDatasource {
    this.sourceReminderData = {} as IReminderData;
    return this;
  }

  write(newReminderData: IReminderData): ReminderConfirmDatasource {
    this.sourceReminderData = _4.assign(this.sourceReminderData, newReminderData);
    return this;
  }

  read(): IReminderData {
    return this.sourceReminderData;
  }

  clear(): void {
    this.initialize();
  }

  isEmpty(): boolean {
    return _4.isEmpty(this.sourceReminderData);
  }

  report(fn: IDatasourceReportFn): any[] {
    return fn(this.sourceReminderData);
  }
}

angular.module('data-ng-personal-reminders').service('reminderConfirmDatasource', ReminderConfirmDatasource);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/datasources/create_reminder_datasource.ts